import React, { useState, useEffect } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { RayTable, RayTreeview, AdminProductListHeader } from '../../components/common';
import ProductTransferModal from '../../components/product/ProductTransferModal';
import DeepSearch from '../../components/common/DeepSearch';
import CustomHeader from '../../components/common/CustomHeader';
import { ProductAction } from '../../actions/ProductAction';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { ProductConstant } from '../../actions/constants/ProductConstant';
import { CustomFieldAction } from '../../actions';
import { AlertAction } from '../../actions/AlertAction';
import { Translate as t } from '../../config/Translate';
import { buildDeepSearchMatch } from '../../lib/deepSearchMatch';
import axios from 'axios';
import { AppConfig, JWT } from '../../config';
import { utils, writeFile } from 'xlsx';
import Loader from 'react-loader-spinner';
import { computeTotalPages, getStopReason, sanitizeCell } from '../../lib/export/paginationHelpers';
import { canTransferProductOperator } from '../../lib/rbacGuard';
import { applyHeaderPrefs } from '../../lib/headerPrefs';
// IMP-446 (#414): 전체 Export 컬럼 선택 모달 + 판정 SSoT 위임.
import ExportColumnModal from '../../components/common/ExportColumnModal';
import { selectExportColumns } from '../../lib/exportColumns';

// IMP-444 (#403): Product 는 Site/User/Service 와 달리 dfilters 교집합이 아니라
// baseHeaderNames(기본 컬럼 name 목록)로 저장값 중 기본 컬럼을 걸러낸다. 저장값에
// 표시/숨김·순서 보존을 위해 기본 컬럼이 함께 저장되기 시작하면서, 걸러내지 않으면
// AdminProductListHeader.concat(exheader) 에서 기본 컬럼이 중복 렌더된다.
export const computeProductExHeader = (user, baseHeaderNames) => {
	const saved = user?.adminheaders?.products;
	if (!saved) return [];
	if (!Array.isArray(baseHeaderNames)) return saved;
	return saved.filter(x => !baseHeaderNames.includes(x?.name));
};

// IMP-444/Spec §5.1 규칙2 — '전체 Export' 의 컬럼 구성도 리스트의 표시 상태(visible)를 따른다.
// BUTTON 컬럼은 출력 대상이 아니다. 원본 배열·원소를 mutate 하지 않는다.
// IMP-446: 판정은 exportColumns.js SSoT(selectExportColumns)에 위임한다. export 이름·시그니처는
// 기존 테스트가 직접 호출하므로 그대로 유지(IMP-444 회귀 가드).
export const selectProductExportColumns = (header) =>
	selectExportColumns(header, null);

const ModalDIMDOAClear = ({ showModal, type, callback, callbackClose }) => {
	const [comment, setComment] = useState("");

	return (
		<Modal show={showModal} onHide={() => callbackClose(false)} className="action-sheet">
			<Modal.Header>
				<h2 className="modal-title">{type == "CLEARDIM" ? t('product.button.clearDim') : t('product.button.clearDoa')}</h2>
			</Modal.Header>
			<Modal.Body className="p-0">
				<ul className="listview simple-listview no-space border-0 m-2">
					<div className="form-group basic">
						<div className="input-wrapper">
							<label className="label">{t('common.field.description')} ({t('common.field.clearReason')})</label>
							<textarea className="form-control"
								rows={5}
								onChange={(e) => setComment(e.target.value)}
								defaultValue={comment}></textarea>
						</div>
					</div>
				</ul>
			</Modal.Body>
			<Modal.Footer>
				<button
					className="btn btn-block btn-primary mb-0"
					onClick={() => { callback(comment); callbackClose(false); }}>{type == "CLEARDIM" ? t('product.button.clearDim') : t('product.button.clearDoa')}</button>
				<button className="btn btn-block btn-dark" onClick={() => callbackClose(false)}>{t('common.button.cancel')}</button>
			</Modal.Footer>
		</Modal>
	);
}

const AdminProductList = ({ customs, su, user, GetProductAll, GetProductAllV2, BulkUpdateProductInfo, products, totalproductcount,
	filterDateOptions, filterOptions, sort, dsfilters, page, companies, viewTree, BulkUpdateTransferInfo }) => {
		const { companyId } = useParams();
	const [header, setHeader] = useState([]);
	const [exheader, setExHeader] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showDSModal, setShowDSModal] = useState(false);
	const [showTModal, setShowTModal] = useState(false);
	const [bulkList, setBulkList] = useState([]);
	const [bulkType, setBulkType] = useState("");
	const [nowuserfilter, setnowuserfilter] = useState({});

	const [filters, setFilters] = useState([]);
	const [filterData, setFilterData] = useState([]);
	const [showCHModal, setShowCHModal] = useState(false);

	const [wHg, setwHg] = useState(300);
	const [wAll, setwAll] = useState(window.innerWidth);
	const [ready, setReady] = useState(false);
	const [match, setMatch] = useState({});
	const [filterCompanyId, setFilterCompanyId] = useState("");
	const [filterCompany, setFilterCompany] = useState({ name: "ALL" });
	const [dfilters, setdFilters] = useState(false);
	const dispatch = useDispatch();

	const [companyList, setCompanies] = useState([]);

	const [payloads, setPayloads] = useState({});
	const [downloading, setDownloading] = useState(false);
	// IMP-446 — 전체 Export 컬럼 선택. 선택은 그 실행에만 적용되며 저장하지 않는다(IMP-444 §5.1 규칙 4).
	const [showExportColumnModal, setShowExportColumnModal] = useState(false);
	const [exportProgress, setExportProgress] = useState(null); // { cur, total } | null

	const setCompanySelect = () => {
		const cList = [];
		companies.map((c) => cList.push({ code: c.companyId, title: "[" + c.country + "] " + c.name }));
		setCompanies(cList);
	};

	useEffect(() => {
		user.adminType != "U" && updateViewTree(true);
	}, []);

	const [tData, setTData] = useState({
		newsn: "",
		nowsn: "",
		companyId: user.companyId,
		reason: "",
	});

	const filterpage = {
		filters: {},
		filterOptions: ['model'],
		searchCols: ['model', 'option', 'sn', 'site.sitename'],
		sort: sort || { updateDate: -1 },
		searchKey: "",
		match: match,
		page: page || 1,
		itemperpage: 30
	};

	const options = {
		isShowCheckBox: true,
		showClear: true,
		search: true,
		keyCol: 'sn',
		defaultSort: filterpage.sort && Object.keys(filterpage.sort)[0],
		defaultSortType: filterpage.sort && Object.values(filterpage.sort)[0],
		linkto: '/Admin/AdminProductInfo',
		getList: GetProductAllV2,
		linkkey: 'sn',
		filterpageoption: filterpage,
		filters: filterpage.filters,
		itemperpage: filterpage.itemperpage,
		useapi: true,
		totalitemcount: totalproductcount,
		filterOptions: filterOptions
	};

	useEffect(() => {
		if (companyId) {
			GetProductAll({ companyId: companyId });
		}
	}, [companyId]);

	useEffect(() => {
		setFilters(user.filters || []);
	}, [user.filters]);

	useEffect(() => {
		setReady(header.length > 0);
	}, [header]);

	useEffect(() => {
		const baseNames = Array.isArray(AdminProductListHeader) ? AdminProductListHeader.map(x => x?.name) : [];
		setExHeader(computeProductExHeader(user, baseNames));
	}, [user.adminheaders?.products, dfilters]);

	useEffect(() => {
		const composed = exheader.length > 0 ? AdminProductListHeader.concat(exheader) : AdminProductListHeader;
		setHeader(applyHeaderPrefs(composed, user?.adminheaders?.products));
	}, [exheader, user?.adminheaders?.products]);

	useEffect(() => {
		if (viewTree) {
			setwHg(300);
		} else {
			setwHg(0);
		}
	}, [viewTree]);

	useEffect(() => {
		callbackDs(dsfilters);
	}, [dsfilters]);

	const getWidth = () => setwAll(window.innerWidth);

	useEffect(() => {
		dispatch({ type: ProgramConstant.SET_PRODUCTLISTISSTOCK, isstock: false })
	}, []);

	useEffect(() => {
		if (companies.length > 0)
			setCompanySelect();
	}, [companies]);

	const onChangeTreeviewItem = (item) => {
		setFilterCompanyId({ companyId: item.id });
		setFilterCompany(item);
	}

	const checkedList = (list) => {
		setBulkList(list);
	}

	const doBulkCallback = (comment) => {
		const data = bulkType == "CLEARDIM" ?
			{
				dim: false,
				"$push": {
					dimlogs: {
						comment: comment,
						user: user.adminid,
						dim: false,
						timestamp: new Date().getTime()
					}
				}
			} : {
				doa: false,
				"$push": {
					doalogs: {
						comment: comment,
						user: user.adminid,
						doa: false,
						timestamp: new Date().getTime()
					}
				}
			}
		setShowModal(false);
		BulkUpdateProductInfo(bulkList, data);
	}

	const doTransferBulkCallback = async (selval, reason) => {
		setShowTModal(false);
		const result = await BulkUpdateTransferInfo(bulkList, selval, reason);
		// merge-by-sn 갱신은 이전된 행을 회사 필터 목록에 남기므로 마지막 필터로 재조회
		if (result?.status === 'success') GetProductAllV2(payloads);
	}

	const bulkActionDo = (action) => {
		setBulkType(action);
		action == "OPTRANSFER" ? setShowTModal(true) : setShowModal(true);
	}

	// SEC-051: OPTRANSFER 는 제품 소유 회사(companyId) 일괄 이전이다. 판정은 rbacGuard 의
	//   공유 primitive 를 쓴다 — 같은 정책이 필요한 화면이 3곳(본 화면 / AdminProductCompanyImport
	//   = BE updatetransferbulk, AdminProductStockList = BE updatebulk)이라 인라인 복제 시
	//   게이트가 갈린다. BE 는 세 경로 모두 canCallerChangeCompanyIdTo 로 같은 선행 게이트를 건다.
	const canTransferOperator = canTransferProductOperator({ adminType: user?.adminType });
	const bulkActions = [
		{ title: t('product.button.clearDim'), action: "CLEARDIM" },
		{ title: t('product.button.clearDoa'), action: "CLEARDOA" },
		...(canTransferOperator ? [{ title: t('common.button.transfer'), action: "OPTRANSFER" }] : [])
	]

	const conSearch = () => {
		setShowDSModal(true);
	}

	const callbackchangeuserfilter = (data) => {
		setnowuserfilter(data);
		dispatch({ type: ProductConstant.UPDATE_DSFILTER, dsfilters: data.filter ? [...data.filter] : [] });
	}

	const callbackDs = (filter) => {
		setMatch(buildDeepSearchMatch(filter));
	}

	// [모두 지우기]: 상세 검색 조건(리덕스)·저장 필터 선택도 초기화. 열린 상세 검색 창은 내부 filter state 가
	// dsfilters prop 을 따라가지 않으므로 닫아서 옛 조건이 남지 않게 한다. 조건이 이미 비었으면 dispatch 하지 않는다(재조회 방지).
	// 조건을 실제로 비웠을 때만 { match: {} } 를 돌려 RayTable 이 그 조건으로 한 번만 조회하게 한다.
	const clearDeepSearch = () => {
		setnowuserfilter({});
		setShowDSModal(false);
		if (!Array.isArray(dsfilters) || dsfilters.length === 0) return undefined;
		dispatch({ type: ProductConstant.UPDATE_DSFILTER, dsfilters: [] });
		return { match: {} };
	}

	const defaultFilter = [
		//STRING, DATETIME, BOOLEAN
		{ code: "company.country", name: t('common.field.country'), type: "COUNTRY" },
		{ code: "companyId", name: t('user.type.operator'), type: "OPERATOR" },
		{ code: "errs.code", name: t('product.field.errorCode'), type: "ERRORCODES" },
		{ code: "codes", name: t('common.label.codes'), type: "STRING" },
		{ code: "option", name: t('common.label.option'), type: "OPTION" },
		{ code: "lastConnectedDate", name: t('common.label.lastConnectedDate'), type: "DATETIME" },
		{ code: "lastDisconnectedDate", name: t('common.label.lastDisconnectedDate'), type: "DATETIME" },
		{ code: "installedDate", name: t('common.label.installDate'), type: "DATETIME" },
		{ code: "productTWId", name: t('common.label.thingworxId'), type: "STRING" },
		//{ code : "sitename", name : "Site Name(LIKE)", type : "LIKESTRING" }, // sites lookup 은 성은 이슈로 제외 20211229
		{ code: "isConnected", name: t('common.label.isConnected'), type: "BOOLEAN" },
		{ code: "comments.comment", name: t('common.field.comment'), type: "LIKESTRING" },
		{ code: "dim", name: t('product.field.dim'), type: "BOOLEAN" }, //STRING, DATETIME, BOOLEAN
		{ code: "doa", name: t('product.field.doa'), type: "BOOLEAN" },
		{ code: "registerd", name: t('common.status.registered'), type: "DATETIME" },
		{ code: "manufactured", name: t('common.label.manufacturedDate'), type: "DATETIME" },
		{ code: "waranties.category", name: t('common.label.warrantyCategory'), type: "WARRANTYTYPE" },
		{ code: "waranties.dest", name: t('common.label.warrantyProduct'), type: "WARRANTYPRODUCT" },
		{ code: "waranties.period", name: t('common.label.warrantyPeriod'), type: "DATETIME" }
	]

	useEffect(() => {
		const newfilters = [];
		customs.filter(m => m.group.includes("PRODUCT")).map(x => {
			if (x.valuetype == "FIXLIST") {
				const mList = [];
				x.listvals.map(l => mList.push({ code: l, title: l }));
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title, fixlist: mList });
			} else {
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title });
			}
		});
		defaultFilter.map(x => newfilters.push(x));
		setdFilters(newfilters);
	}, [customs]);

	const updateViewTree = (bl) => {
		dispatch({ type: ProgramConstant.VIEWTREE, val: bl });
	}

	// IMP-446: selectedNames 는 ExportColumnModal 확인 결과(선택 컬럼 name 배열)다. 인자 없이 호출해도
	// (기존 호출부/테스트 호환) selectExportColumns 가 비배열 입력에 기본 체크값으로 폴백한다.
	const exportAllDevices = async (selectedNames) => {
		setDownloading(true);

		let current_page = 1;
		// PR #250 review Minor — 첫 응답의 실제 list.length 를 페이지 사이즈 기준으로 산정 (BUG-115).
		let total_page = 0;
		// BUG-115: BE MakeList(common.js IMP-139) 는 itemperpage 를 MAX_ITEMS_PER_PAGE 로 silent clamp.
		//   요청값을 BE 클램프 값과 동일하게 맞추고, 실제 반환된 list.length 를 ground truth 로 total_page 를 계산한다.
		// IMP-235 (2026-05-20): BE MAX 200→1000 상향. 27,430건 export 138→28 round-trip (5배 단축, 10분+ → 2분대).
		// IMP-232: BE 응답 메타(actualPerPage)를 total_page 산정의 ground truth 로 사용하면서
		//   본 상수의 BE 클램프 동기화 의무는 해소됨. 이제 count_per_page 는 요청 페이지 사이즈(round-trip 횟수=성능)만
		//   좌우하며 정확성과는 무관. BE MAX(1000)를 초과 요청해도 clamp 되므로 그 값에 맞춰 두는 것이 최적.
		const count_per_page = 1000;
		// PR #250 review Major (Security): BE totalcount 무검증 신뢰 시 응답 변조/race 로 루프 폭주 위험.
		const MAX_ALLOWED_TOTAL = 100000;
		// PR #250 review Minor (Security): 클라이언트 메모리 고갈 방어. 누적 행수 상한.
		const MAX_EXPORT_ROWS = 100000;

		const result = [];
		let stopReason = null;

		while (true) {
			let response;
			try {
				//const ret = await axios.post(AppConfig.API_SERVER_PATH + '/product', data, JWT());
				//const response = await axios.post('https://api.raymedical.com/api/product',
				// IMP-295: /product(getAll, getPermList) 은 companies+sites $lookup 을 매칭셋 전체에 수행하는
				//   IMP-139 이전 레거시 경로라 페이지당 ~5초 지연. 목록 조회와 동일한 denormalized 경로
				//   /productv2(getAllV2, baseFilterV2 — $lookup 제거)로 전환해 export 페이지당 ~6배 단축.
				//   응답 shape·컬럼 동일(목록 테이블이 이미 /productv2 로 같은 header 렌더 중).
				response = await axios.post(AppConfig.API_SERVER_PATH + '/productv2',
					{
						type: "get",
						data: {
							...payloads,
							page: current_page,
							itemperpage: count_per_page,
							// BUG-234: export 는 29회로 나눠 요청하므로 $skip/$limit 가 요청 간에 안정적이어야 한다.
							//   화면 정렬 키 updateDate 는 가변/비유일이라, export 도중 갱신된 장비가 이미 읽고
							//   지나간 앞 페이지로 점프해 영구 누락되고 뒤쪽 장비가 중복 수집된다(행 수는 그대로).
							//   불변/유일 키 _id 로 고정하면 갱신 점프와 동점 흔들림이 함께 사라진다.
							//   화면 목록 정렬은 그대로이며, 바뀌는 것은 export 파일의 행 순서뿐이다.
							sort: { _id: 1 }
						}
					}, JWT());
			} catch (error) {
				// PR #250 review Minor (Security): JWT 만료(401) 등 네트워크 오류를 명시 분기.
				//   138회 루프 도중 토큰 만료 시 사용자에게 부분 export 임을 알림.
				if (error?.response?.status === 401) {
					stopReason = 'AUTH_EXPIRED';
				} else {
					// PR #250 2차 review Sec Minor: raw axios error 객체에 config.headers.Authorization(JWT)
					// 포함될 수 있어 DevTools 노출 위험. 안전 필드만 추출하여 로깅.
					console.error('[exportAllDevices] Network error', {
						message: error?.message,
						status: error?.response?.status,
						url: error?.config?.url,
					});
					stopReason = 'NETWORK_ERROR';
				}
				break;
			}

			if (response.data.status === 'success') {
				// PR #250 review Major (Security): response.data.data null/undefined 방어.
				const responseData = response.data?.data;
				if (!responseData) {
					console.error('[exportAllDevices] Unexpected response structure', response.data);
					stopReason = 'INVALID_RESPONSE';
					break;
				}
				// BUG-115: response 의 list 를 단일 변수(responseList)로 통일. 변환은 in-place mutate.
				const responseList = responseData.list || [];
				if (total_page === 0) {
					const total_count = responseData.totalcount;
					// PR #250 review Major (Security): totalcount 상한 가드. 변조/race 시 무한 루프 방어.
					// PR #250 2차 review Sec Minor: Number.isFinite 사용 — typeof NaN === 'number' bypass 차단.
					if (!Number.isFinite(total_count) || total_count < 0 || total_count > MAX_ALLOWED_TOTAL) {
						console.error('[exportAllDevices] Unexpected totalcount', total_count);
						stopReason = 'INVALID_TOTAL';
						break;
					}
					// BUG-115: 요청한 count_per_page 가 아닌 실제 반환된 페이지 사이즈로 계산.
					// IMP-232: BE 응답 메타 actualPerPage(clamp 후 실제 페이지 사이즈)를 ground truth 로 사용.
					//   postFilter/마지막 페이지로 list.length 가 줄면 responseList.length 분모는 total_page 를
					//   과대 계산할 수 있음 → actualPerPage 우선. 미제공(구 BE) 시 기존 responseList.length fallback.
					const page_size = responseData.actualPerPage || responseList.length || count_per_page;
					total_page = computeTotalPages(total_count, page_size);
				}

				const newCols = [];
				// PR #250 review Major: header 가 평면 객체이므로 얕은 복사로 충분 (deep clone 비용 제거).
				// IMP-444/Spec §5.1 규칙2: BUTTON 제외 + 표시(visible) 상태 반영은 selectExportColumns 가 담당.
				// IMP-446: 모달에서 고른 selectedNames 를 그대로 전달 — 미선택(undefined)이면 기본 체크값 폴백.
				const nowCols = selectExportColumns(header, selectedNames).map(col => ({ ...col }));

				// PR #250 review Major: 반환값을 사용하지 않는 .map() 은 .forEach() 로 교체 (GC 압력 감소).
				nowCols.forEach(x => {
					if (x.name.indexOf(".") > 0) {
						const newKey = x.name.replace(".", "");
						const keyarr = x.name.split(".");
						responseList.forEach((y) => {
							try {
								y[newKey] = y[keyarr[0]][keyarr[1]];
							} catch { }
						});
						newCols.push({ ...x, name: newKey });
					}
					else {
						newCols.push(x);
					}
				});

				newCols.forEach(x => {
					if (x.type === "DT" || x.type === "DATETIME" || x.type === "DTONLY") {
						responseList.forEach(y => {
							y[x.name] = (y[x.name] && y[x.name] !== 0) ? moment(y[x.name]).local().format('YYYY-MM-DD HH:mm:ss') : '';
						});
					}
					// BUG-153: OPERATOR 도 COMPANY 와 동일하게 companyId→회사명 해석.
					//   IMP-295(/productv2 denormalized 전환) 후 export 가 OPERATOR 미처리로 raw companyId 코드를
					//   출력하던 회귀 수정. 리스트(RayTable.js:802)는 이미 companies 배열로 동일 해석 중.
					if ((x.type === "COMPANY" || x.type === "OPERATOR") && companies.length > 0) {
						responseList.forEach(y => {
							// PR #250 2차 review CQ Minor: == → === (1차에서 누락된 잔존 케이스).
							const cid = companies.filter(n => n.companyId === y[x.name]);
							if (cid.length > 0) {
								y[x.name] = cid[0].name;
							}
						});
					}
					if (x.type === 'ARRAYLIST') {
						responseList.forEach(y => {
							// BUG-115 review Major: undefined 방어. Array 가 아닌 값(null/undefined/non-array)도 안전 처리.
							y[x.name] = Array.isArray(y[x.name]) ? y[x.name].toString() : (y[x.name] ?? '');
						});
					}
				});

				// PR #250 review Major (Security): Excel Formula Injection (OWASP A03) 방어.
				//   `=`, `+`, `-`, `@`, `\t`, `\r` 로 시작하는 셀 값에 `'` prefix 추가.
				result.push(...responseList.map(x => {
					const filtered = {};
					newCols.forEach(y => { filtered[y.label] = sanitizeCell(x[y.name]); });
					return filtered;
				}));

				// IMP-446 (FR-008): 페이지 처리를 마칠 때마다 진행률 갱신.
				setExportProgress({ cur: current_page, total: total_page });

				// PR #250 review Minor (Security): 메모리 고갈 방어. 누적 행수 상한 초과 시 종료.
				if (result.length >= MAX_EXPORT_ROWS) {
					console.warn('[exportAllDevices] MAX_EXPORT_ROWS reached', { rows: result.length });
					stopReason = 'MAX_ROWS_REACHED';
					break;
				}

				// PR #250 review Architecture Minor: 종료 사유 호출부 노출 (UX 안내용).
				const reason = getStopReason(current_page, total_page, responseList.length);
				if (reason !== null) {
					stopReason = reason;
					break;
				}
			} else {
				// BUG-115: 실패 응답 시 무한 루프 방지. 부분 결과로 종료.
				stopReason = 'API_FAILED';
				break;
			}

			current_page++;
		}

		// PR #250 review Minor (Security/UX): 부분 export 발생 시 사용자에게 명시 안내.
		//   COMPLETED 정상 종료 외의 종료 사유는 부분 결과이므로 console 경고 + 다국어 안내.
		if (stopReason && stopReason !== 'COMPLETED') {
			const partialMsg = {
				AUTH_EXPIRED: t('io.message.error.sessionExpiredDuringExport'),
				NETWORK_ERROR: t('io.message.error.networkErrorDuringExport'),
				INVALID_RESPONSE: t('io.message.error.unexpectedServerResponseDuringExport'),
				INVALID_TOTAL: t('io.message.error.unexpectedTotalCountExportAborted'),
				API_FAILED: t('io.message.error.serverErrorDuringExport'),
				MAX_ROWS_REACHED: t('io.message.error.exportRowLimitReached'),
				EMPTY_PAGE: t('io.message.error.serverEmptyPageDuringExport'),
				NO_DATA: t('io.message.error.noDataToExport'),
			}[stopReason];
			if (partialMsg) {
				dispatch(AlertAction.ErrorMsg(partialMsg));
			}
		}

		const ws = utils.json_to_sheet(result);
		const wb = utils.book_new();

		utils.book_append_sheet(wb, ws, "Sheet1");

		setDownloading(false);
		// IMP-446 (FR-008): 정상 종료·오류 break 모든 경로가 이 지점을 지나므로 여기서 한 번만 지운다.
		setExportProgress(null);

		writeFile(wb, `Product-List-${moment().format("YYYYMMDDHHmmss")}.xlsx`);
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('product.title')}
					{companies.length > 1 && <button className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => updateViewTree(!viewTree)}>
						{filterCompany.name && <>
							{filterCompany.country && "[" + filterCompany.country + "] "}{filterCompany.name}
						</>}
					</button>}
				</h2>
				<div className="ray-right">
					{/* IMP-446: 클릭 즉시 조회하지 않고 컬럼 선택 모달을 연다. */}
					<button onClick={() => setShowExportColumnModal(true)} className="btn btn-sm mt-0">
						{
							downloading &&
							<Loader
								type='TailSpin'
								color='#000'
								width={15}
								height={15}
								visible={downloading}
								radius={2}
								style={{ display: 'inline-block', marginRight: '10px' }} />
						}

						{
							!downloading &&
							<ion-icon name="cloud-download-outline"></ion-icon>
						}
						{t('common.button.exportdata')}
					</button>
					{/* IMP-446 (FR-008): 진행률 표시. 신규 키를 만들지 않고 기존 common.message.info.searching('검색 중...')을 재사용한다. */}
					{exportProgress && (
						<span className="ms-1" data-testid="export-progress">
							{t('common.message.info.searching')} {exportProgress.cur} / {exportProgress.total}
						</span>
					)}

					<button onClick={() => setShowCHModal(true)} className="btn btn-sm mt-0">
						<ion-icon name="options-outline"></ion-icon> {t('common.label.customHeaders')}
					</button>
					{
						(user.adminType == 'S' && user.companyId != 'RAY02091') && <Link to="/Admin/AdminProductImport" className="btn btn-sm mt-0">
							<ion-icon name="share-outline"></ion-icon> {t('product.button.importDevices')}
						</Link>
					}
					<Link to="/Admin/AdminProductDashboard" className="btn btn-sm mt-0">
						<ion-icon name="desktop-outline"></ion-icon> {t('dashboard.title')}
					</Link>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{(viewTree && user.adminType != "U") &&
					<div className={viewTree ? "section fl p-0" : "section p-0 fl"} style={{ width: wHg }}>
						<div className='p-1'>
							<RayTreeview onClickItem={onChangeTreeviewItem} onResize={setwHg} stateKey={LIST_STATE_KEYS.ADMIN_PRODUCT} />
						</div>
					</div>}
				<div className="section m-1 p-0">
					<div className="card p-2">
						<div className={user.adminType != "U" ? "fl" : ""} >
							{showDSModal && <div className="mb-1">
								<DeepSearch
									extratrakey={"PRODUCTEXTRAKEY"}
									extratrakeyname={"extradata"}
									filterData={filterData}
									dsfilters={dsfilters || []}
									nowuserfilter={nowuserfilter}
									callbackDs={callbackDs}
									callbackchangeuserfilter={callbackchangeuserfilter}
									callbackDSClose={() => setShowDSModal(false)}
									defaultFilter={su ? dfilters : dfilters.filter(x => x.code != "companyId")} />
							</div>}
							{ready && <RayTable
								stateKey={LIST_STATE_KEYS.ADMIN_PRODUCT}
								data={products}
								listtype={"product"}
								ufilters={filters.length > 0 ? filters.filter(x => x.type == "product") : []}
								match={match}
								dsfilterCount={dsfilters.length}
								conSearch={conSearch}
								addFilter={filterCompanyId}
								exportlocalaction={ProductAction.GetProductAllLocal}
								bulkActions={bulkActions}
								bulkActionDo={bulkActionDo}
								callbackchangeuserfilter={callbackchangeuserfilter}
								onClear={clearDeepSearch}
								checkBoxCallback={(list) => checkedList(list)}
								columns={header}
								options={options}
								payloadCallback={(pl) => setPayloads(pl)}
							/>}
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
			<CustomHeader
				extratrakey={"PRODUCTEXTRAKEY"}
				title={t('product.label.productListHeader')}
				extratrakeyname={"extradata"}
				exHeader={exheader}
				adminheaderprefix={"products"}
				showModal={showCHModal}
				callbackClose={() => setShowCHModal(false)}
				defaultFilter={dfilters || []}
				baseHeader={header} />
			{/* IMP-446: columns 는 표시 필터를 거치지 않은 전체 header 그대로 전달 — 판정은 ExportColumnModal 내부(exportColumns.js)가 한다. */}
			<ExportColumnModal
				showModal={showExportColumnModal}
				columns={header}
				callbackClose={() => setShowExportColumnModal(false)}
				callbackConfirm={(names) => {
					setShowExportColumnModal(false);
					exportAllDevices(names);
				}} />
			<ModalDIMDOAClear showModal={showModal}
				callbackClose={() => setShowModal(false)}
				type={bulkType}
				callback={(comment) => doBulkCallback(comment)} />
			<ProductTransferModal show={showTModal}
				onClose={() => setShowTModal(false)}
				onTransfer={(selval, reason) => doTransferBulkCallback(selval, reason)}
				companies={companyList}
			/>
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	const su = state.AuthReducer.su;
	const viewTree = state.ProgramReducer.viewtree;
	const companies = state.CompanyReducer.companies;
	const products = state.ProductReducer.products;
	const dsfilters = state.ProductReducer.dsfilters;
	const totalproductcount = state.ProductReducer.totalproductcount;
	const filterOptions = state.ProductReducer.filterOptions;
	const filterDateOptions = state.ProductReducer.filterDateOptions;
	const filters = state.ProductReducer.filters;
	const page = state.ProductReducer.page;
	const sort = state.ProductReducer.sort;
	const customs = state.CustomFieldReducer.items;
	return { customs, user, su, products, totalproductcount, filterOptions, filters, sort, filterDateOptions, dsfilters, page, viewTree, companies };
};

const mapDispatch = (dispatch) => ({
	GetProductAll: (filter) => dispatch(ProductAction.GetProductAll(filter)),
	GetProductAllV2: (filter) => dispatch(ProductAction.GetProductAllV2(filter)),
	BulkUpdateProductInfo: (sns, data) => dispatch(ProductAction.BulkUpdateProductInfo(sns, data)),
	BulkUpdateTransferInfo: (sns, data, reason) => dispatch(ProductAction.BulkUpdateTransferInfo(sns, data, reason)),
});

export default connect(mapState, mapDispatch)(AdminProductList);
